// test1649
(1649 && 0);
